module.exports = __webpack_public_path__ + "static/media/webapp.06980abe.svg";